import axios, { AxiosError, AxiosRequestConfig } from 'axios'

import { apiUrl } from '@/data/appConfig'
import router from '@/router'
import { logger, refreshUserToken } from '@/sdk/oauth'
import store from '@/store'

const onRefreshTokenError = () => {
  store.commit('auth/deleteAuth')
  router.replace('/login')

  return Promise.reject(new Error('Error while refreshing user token'))
}

const refreshToken = async () => {
  try {
    const newToken = await refreshUserToken()

    if (!newToken) {
      return onRefreshTokenError()
    }

    Promise.resolve()
  } catch (error) {
    return onRefreshTokenError()
  }
}

/**
 * Unauthorized Interceptor
 *
 * Intercepts requests and handles 401 responses.
 * If there is an unauthorized response (401), the request will be held
 * until the token is refreshed
 */
export default async (
  error: AxiosError,
): Promise<AxiosRequestConfig | AxiosError> => {
  const status =
    error.response && error.response.status ? error.response.status : 0
  const originalRequest = error.config

  if (status === 401 || error.message === 'Network Error') {
    await refreshToken()

    const request = {
      ...originalRequest,
      headers: {
        ...(originalRequest.headers || {}),
        Authorization: `Bearer ${store.getters['auth/userToken']()}`,
      },
      url: (originalRequest.url || '').split(apiUrl).join(''),
    }

    logger(
      'userRequest -> 401 response -> changed to request with new bearer token -> %O',
      originalRequest,
    )

    return axios(request)
  }

  return Promise.reject(error)
}
